import {
    Component,
    OnInit,
    Input,
    NgModule,
    Output,
    EventEmitter,
    TemplateRef,
    Type,
    ComponentFactory,
    ViewChild,
    ViewContainerRef,
    ComponentRef,
    ContentChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { GridUtilService } from './share/grid-util.service';
import { API } from '../services/api';
import { DirectivesModule } from '../share/directives/yzt-directives.modules';
import { YZTViewerDirectiveModule } from '../yzt-viewer/yzt-viewer.directive';
import { Subject } from 'rxjs/Subject';

declare var _; // 依赖lodash _.get，_.set

export interface PageData {
    content: Array<any>;
    numberOfElements: number;
    [portName: string]: any;
}
class GridIconIF {
    field: '';
    prop: '';
    iconTemplate: TemplateRef<any>
}

function GridIconIF_tsickle_Closure_declarations() {
/** @type {?} */
GridIconIF.prototype.field;
/** @type {?} */
GridIconIF.prototype.prop;
/** @type {?} */
GridIconIF.prototype.iconTemplate;
}


export interface PageIndexAndSize {
    page: number,
    size: number
}
export class UIGridComponent {
     gridImg: ViewContainerRef;
     nzTable: any;

    _data: PageData = { content: [], numberOfElements: 0 };
    _dataSet = [];
    _selections: any;
    _loading = false;
/**
 * @param {?} v
 * @return {?}
 */
set loading(v: boolean) {
        this._loading = !!v;
    }
    _fixScrollY = 0;
    _title = '';
    _titleTpl: TemplateRef<any>;
    _exportLoading = false;
    _editCol = false;
    //用于存放可选列
    targetColumns: any[] = [];
    //备份完整columns
    editColumns: any[] = [];
    //grid表格按钮控制
    buttonGather = {
        showEditColumn: false,
        enableExport: false,
    }
/**
 * @param {?} num
 * @return {?}
 */
set pageIndex(num) {
        if (this._page === num) return;
        this._page = num

    }
/**
 * @return {?}
 */
get pageIndex() {
        return this._page;
    }
/**
 * @param {?} num
 * @return {?}
 */
set pageSize(num) {
        if (this._size === num) return;
        this._size = num
    }
/**
 * @return {?}
 */
get pageSize() {
        return this._size;
    }

    _page = 1;
    _size = 10;
private _pageIndex = 1;
private _pageSize = 1;
/**
 * 控制多选
 */
_allChecked = false;
    _indeterminate = false;
    _displayData = [];
    // 自定义图片实例
    _iconComp = {};
    // 自定义单元格
    _customComp: { [k: string]: any } = {};
    // 表头搜索
    _searchCustom: { [k: string]: TemplateRef<any> } = {};
    _hasSearch: number;
    // 存储转换后的卡片字符串
    _popoverStr = '';
    _popoverArr = [];
/**
 * @param {?} show
 * @return {?}
 */
set editCol(show: boolean) {
        if (show) {
            this.editColumns = [...this.columns, ...this.targetColumns];
        }
        this._editCol = show;
    }

     load: EventEmitter<PageIndexAndSize> = new EventEmitter();
     selectionChange: EventEmitter<any> = new EventEmitter();
     cellClick: EventEmitter<any> = new EventEmitter();
     cellOver: EventEmitter<any> = new EventEmitter();
     exportCSV: EventEmitter<any> = new EventEmitter();

     id: string;
     columns = [];
     showSizeChanger = false; // 未知用途
     showPagination = true; // 是否显示分页
     pageSizeValues = [10, 30, 50, 100];
     showTitle = true;
     mulitipy = false;
     selectColor = '#FCF5F0';
     isSyncData = false;
/**
 * @param {?} value
 * @return {?}
 */
set data(value: PageData) {
        this._loading = false;
        if (!value) return;
        // 手动调用查询，解决分页问题
        if (value.size) {
            this.pageSize = value.size;
            this.pageIndex = value.number + 1;
            this._pageIndex = this.pageIndex; // 控制查询的时候，引起的pageIndexChange事件造成走两次接口
            this._pageSize = this.pageSize; // 控制查询的时候，引起的pageSizeChange事件造成走两次接口
        }
        let /** @type {?} */ content = value['content'] || [];
        // 优化性能。解决表格重复赋值
        for (let /** @type {?} */ row of content) {
            for (let /** @type {?} */ c of [].concat(this.columns).concat(this.targetColumns)) {
                let /** @type {?} */ fieldValue = _.get(row, c.field); // 兼容后端返回数据结构，eg:c.field="shipper.clientType"
                if (c.field) {
                    Object.defineProperty(row, c.field, { value: fieldValue || "" });
                }
            }
        }
        this._displayData = value['content'] = content;
        this._data = value;
    }
/**
 * @return {?}
 */
get data(): PageData {
        return this._data;
    }
/**
 * @param {?} height
 * @return {?}
 */
set fixScroll(height: any) {
        this._fixScrollY = parseInt(height);
    }
/**
 * @param {?} value
 * @return {?}
 */
set title(value: string | TemplateRef<void>) {
        if (value instanceof TemplateRef) {
            this._titleTpl = value;
        } else {
            this._title = value;
        }
    }
/**
 * @param {?} templs
 * @return {?}
 */
set searchTmpl(templs: any[]) {
        if (templs) {
            let /** @type {?} */ ref;
            templs.forEach((templ, i) => {
                ref = Object.keys(templ._def.references)[0].split('_')[1].toString();
                Object.defineProperty(this._searchCustom, ref, {
                    value: templ
                })
            })
            this._hasSearch = templs.length ? 1 : 0;
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
set selection(value: Array<any>) {
        // 单选接受一个对象多选接受数组
        if (!this.util.isEqual(this._selections, value)) {
            if (!value.length) {
                this._displayData.forEach(data => {
                    data.checked = false;
                });
                this._indeterminate = false;
                this._allChecked = false;
            }
            this._selections = value;
            this.selectionChange.emit(value);
        }
    }
/**
 * @param {?} util
 * @param {?} _vcr
 * @param {?} api
 */
constructor(private util: GridUtilService,
public _vcr: ViewContainerRef,
public api: API) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        if (this.id) {
            let /** @type {?} */ columnsMap = localStorage[this.id];
            if (columnsMap) {
                columnsMap = JSON.parse(columnsMap);
                let /** @type {?} */ sourceColumns = columnsMap["sourceColumns"];
                let /** @type {?} */ targetColumns = columnsMap["targetColumns"];
                if (sourceColumns && targetColumns && this.util.generateColumnKey([...sourceColumns, ...targetColumns]) === this.util.generateColumnKey(this.columns)) {
                    this.columns = sourceColumns;
                    this.targetColumns = targetColumns;
                }
            }
        }
        this.editColumns = this.columns;
        this.editColumns.forEach((column, i) => {
            Object.defineProperties(column, {
                title: { value: column.header },
                disabled: { value: column.transferVisabled || false }
            })
        })
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        if (!this.isSyncData) {
            setTimeout(_ => {
                this.onLazyLoad();
            })
        }
    }
/**
 * @return {?}
 */
ngOnChanges() {
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.id) {
            localStorage[this.id] = JSON.stringify({
                sourceColumns: this.columns,
                targetColumns: this.targetColumns
            });
        }
    }
/**
 * page index change event handler
 * @param {?} $event
 * @return {?}
 */
nzPageIndexChange($event) {
        setTimeout(() => {
            if (this._pageIndex === $event) {
                return;
            }
            this.onLazyLoad();
            this._pageIndex = $event;
        });
    }
/**
 * @param {?} $event
 * @return {?}
 */
pageSizeChange($event) {
        // 控制size改变，引起pageIndex变化而产生多次请求
        if (this._pageIndex !== this.pageIndex) {
            return;
        }
        setTimeout(() => {
            if (this._pageSize === $event) {
                return;
            }
            this.onLazyLoad();
        });
    }
/**
 * @param {?} column
 * @return {?}
 */
isNeedSearch(column: any) {
        for (let /** @type {?} */ value in column) {
            if (column[value] && column[value].indexOf('search_') !== -1)
                return column[value].split('_')[1];
        }
        return 0;
    }
/**
 * @param {?} change
 * @return {?}
 */
editChange(change: any) {
        let /** @type {?} */ originChange = change, /** @type {?} */
            items = originChange.list;

        items.forEach((item, index) => {
            if (change.from === 'left') {
                this.editColumns.forEach(column => {
                    if (item['field'] === column['field'] && column.direction !== 'right')
                        column.direction = 'right';
                })
            } else {
                this.targetColumns.forEach(column => {
                    if (item['field'] === column['field'] && column.direction === 'right')
                        column.direction = 'left';
                })
            }
        })

        this.columns = this.editColumns.filter(column => column.direction !== 'right');
        this.targetColumns = this.editColumns.filter(column => column.direction === 'right');
        // 重新赋值，保证穿梭框排序保持最新一次
        this.editColumns = [...this.columns, ...this.targetColumns];
    }
/**
 * @param {?=} page
 * @return {?}
 */
onLazyLoad(page: PageIndexAndSize = { page: this.pageIndex, size: this.pageSize }): any {
        this._loading = true;
        this.load.emit(page);
    }
/**
 * @param {?} __0
 * @return {?}
 */
getIconInstance({ outField, outProp, iconTemplate }) {
        this._iconComp[outField] = {
            outField: outField || '',
            outProp: outProp || '',
            iconTemplate: iconTemplate || '',
        }
    }
/**
 * @param {?} __0
 * @return {?}
 */
getCusTmplInstance({ outField, customTemplate }) {
        this._customComp[outField] = {
            outField: outField || '',
            customTemplate: customTemplate || ''
        }
    }
/**
 * 记录选择事件
 * @param {?} data
 * @return {?}
 */
onRowSelectChange(data: any) {
        data.checked = !data.checked;

        this.mulitipy ? this.refreshStatus() : this.selection = data;

        return false;
    }
/**
 * 选择checkbox
 * @param {?=} event
 * @return {?}
 */
refreshStatus(event?: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        const /** @type {?} */ selections = this._displayData.filter(value => value.checked === true);
        const /** @type {?} */ allChecked = this._displayData.every(value => value.checked === true);
        const /** @type {?} */ allUnChecked = this._displayData.every(value => !value.checked);
        this._allChecked = allChecked;
        this._indeterminate = (!allChecked) && (!allUnChecked);
        this.selection = selections;
    }
/**
 * @param {?} event
 * @param {?} data
 * @param {?} index
 * @return {?}
 */
refreshSingleStatus(event: MouseEvent, data, index: number) {
        if (event) {
            event.stopPropagation();
        }
        data.forEach((val, i) => {
            if (index === i) return;
            val.checked = false;
        })
        this.selection = data.filter(v => v.checked);
    }
/**
 * 全选和反选
 * @param {?} value
 * @param {?} data
 * @return {?}
 */
checkAll(value, data: Array<any>) {
        if (value) {
            this._displayData.forEach(data => {
                data.checked = true;
            });
        } else {
            this._displayData.forEach(data => {
                data.checked = false;
            });
        }
        this.refreshStatus();
    }
/**
 * cell点击事件
 * @param {?} event
 * @param {?} row
 * @param {?} field
 * @return {?}
 */
onCellClick(event: Event, row: any, field: any) {
        event.stopPropagation();
        let /** @type {?} */ value = row[field];
        this.cellClick.emit({
            row: row,
            field: field,
            value: value,
            originalEvent: event
        });
    }
/**
 * 鼠标mouseover事件
 * @param {?} event
 * @param {?} row
 * @param {?} field
 * @return {?}
 */
onCellMouseover(event: any, row: any, field: any) {
        event.stopPropagation();
        // let value = this.value(row, field);
        let /** @type {?} */ value = row[field];
        this.cellOver.emit({
            row: row,
            field: field,
            value: value,
            originalEvent: event
        });
    }
/**
 * 数据转为字符串
 * @param {?} val
 * @return {?}
 */
dataToStr(val: any) {
        let /** @type {?} */ resultData;
        if (typeof val == 'number') {
            resultData = val.toString();
        } else if (typeof val == 'undefined') {
            resultData = '';
        } else if (val == null) {
            resultData = '';
        } else if (typeof val == 'object') {
            resultData = JSON.stringify(val);
        } else if (typeof val == 'boolean') {
            resultData = val ? '是' : '否';
        } else {
            resultData = val;
        }
        return resultData;
    }
/**
 * 对有textLength属性的column进行字节数量控制
 * @param {?} val
 * @param {?=} textLength
 * @param {?=} mergeName 控制popover弹窗,传需要合并的key,eg: [{a: '床'},{a: '被子'}] ,此处mergeName传'a'
 * @return {?}
 */
replaceTextOmit(val: any, textLength: number = 20, mergeName = '') {
        let /** @type {?} */ resultData, /** @type {?} */ temp;
        resultData = this.dataToStr(val);
        if (Object.prototype.toString.call(val) === '[object Array]') {
            let /** @type {?} */ namesArr = _.map(val, mergeName), /** @type {?} */
                namesStr = namesArr.join(',');
            temp = namesStr.slice(0, textLength);
            return namesStr.length > textLength ? `${temp}...` : namesStr;
        }

        if (typeof resultData === 'string') {
            temp = resultData.slice(0, textLength);
            return resultData.length > textLength ? `${temp}...` : resultData;
        } else {
            return resultData;
        }
    }
/**
 * 字符串转数组，逗号隔开, popover在表格中有性能问题，
 * 会触发两次导致第一次会显示表格中最后一个单元格的值再显示想显示的popover数组
 * 临时解决办法必须在html模板中传val值，估计是多次触发表格的变化检测
 * @param {?} val
 * @param {?=} mergeName
 * @return {?}
 */
splitName(val, mergeName = '') {
        let /** @type {?} */ result;
        if (Object.prototype.toString.call(val) === '[object Array]') {
            let /** @type {?} */ namesArr = _.map(val, mergeName), /** @type {?} */
                namesStr = namesArr.join(',');
            result = namesStr;
        } else if (typeof val === 'string') {
            result = val;
        }
        let /** @type {?} */ reg = /[,，]/g;
        result = result.replace(reg, ',');
        return _.compact(result.split(',')) || [];
    }
/**
 *
 * @param {?} grid
 * @param {?} data
 * @param {?=} isFailed 失败了
 * @return {?}
 */
doExportCSV(grid, data, isFailed?: boolean) {
        grid.exportDisable = false;
        if (isFailed) {
            return;
        }
        let /** @type {?} */ columns = grid.columns;
        var /** @type {?} */ csv = '\ufeff';
        //headers
        for (var /** @type {?} */ i = 0; i < columns.length; i++) {
            if (columns[i].field && !columns[i].hidden) {
                csv += '"' + (columns[i].header || columns[i].field) + '"';
                if (i < (columns.length - 1)) {
                    csv += ",";
                }
            }
        }
        //body
        data.forEach(function (record, i) {
            csv += '\n';
            for (var /** @type {?} */ i_1 = 0; i_1 < columns.length; i_1++) {
                if (columns[i_1].field && !columns[i_1].hidden) {
                    let /** @type {?} */ value = Object.defineProperty(record, columns[i_1].field, null);
                    if (typeof value === 'string') {
                        value = value.replace('"', '""');
                    } else if (value === null || value === 'null' || value === 'undefined') {
                        value = "";
                    }
                    if (!isNaN(Number(value)) && value.length > 12) {
                        csv += '"' + value + '\ufeff"';
                    } else {
                        csv += '"' + value + '"';
                    }
                    if (i_1 < (columns.length - 1)) {
                        csv += ",";
                    }
                }
            }
        });
        var /** @type {?} */ blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, '导出.csv');
        }
        else {
            var /** @type {?} */ link = document.createElement("a");
            link.style.display = 'none';
            document.body.appendChild(link);
            if (link.download !== undefined) {
                link.setAttribute('href', URL.createObjectURL(blob));
                link.setAttribute('download', '导出.csv');
                link.click();
            }
            else {
                csv = 'data:text/csv;charset=utf-8,' + csv;
                window.open(encodeURI(csv));
            }
            document.body.removeChild(link);
        }
    }

    exportDisable = false;
/**
 * @return {?}
 */
exportCSVIntenal() {
        let /** @type {?} */ $this = this;
        this.exportDisable = true;
        this.exportCSV.emit({
            done: $this.doExportCSV,
            grid: $this
        });
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `yzt-grid`,
    template: `
      <div class="grid-border">
          <nz-table #nzTable [nzScroll]="!!_fixScrollY?{ y: _fixScrollY }:null" [nzIsPagination]="showPagination" nzShowSizeChanger [nzPageSizeSelectorValues]="pageSizeValues" [nzAjaxData]="_data.content" [nzTotal]="_data.totalElements" [nzLoading]="_loading" [(nzPageIndex)]="pageIndex"
              [(nzPageSize)]="pageSize" (nzPageSizeChange)="pageSizeChange($event)" (nzPageIndexChange)="nzPageIndexChange($event)" [nzShowTitle]="showTitle" [nzShowTotal]="true" [nzSize]="'middle'" nzCustomNoResult="没有记录">
              <div class="table-title" nz-table-title *ngIf="_title || _titleTpl || buttonGather.showEditColumn || buttonGather.enableExport">
                  <ng-template #defaultTitle>
                      <div>
                          <button class="btn-editcol" nz-button [nzType]="'primary'" *ngIf="buttonGather.showEditColumn" (click)="editCol = !_editCol">
                              <i class="anticon anticon-edit"></i><span>编辑列</span>
                          </button>
                          <button class="btn-export" nz-button [nzType]="'primary'" [nzLoading]="_exportLoading" *ngIf="buttonGather.enableExport" (click)="exportCSVIntenal()">
                              <i class="anticon anticon-export"></i><span>导出</span>
                          </button>
                      </div>
                  </ng-template>
                  <ng-template [ngIf]="_title">{{_title}}</ng-template>
                  <ng-template [ngTemplateOutlet]="!_title && (_titleTpl || defaultTitle)"></ng-template>
              </div>
              <ng-template #nzFixedHeader [ngIf]="!_fixScrollY">
                  <thead nz-thead>
                      <tr>
                          <th nz-th nzCheckbox *ngIf="mulitipy">
                              <label nz-checkbox [(ngModel)]="_allChecked" [nzIndeterminate]="_indeterminate" (ngModelChange)="checkAll($event, nzTable.data)">
                              </label>
                          </th>
                          <th nz-th nzCheckbox *ngIf="!mulitipy">
                              <span> </span>
                          </th>
                          <th class="header-title" nz-th *ngFor="let column of columns" [nzWidth]="column.width || '120px'">
                              <span>{{column.header}}</span>
                              <div [ngClass]="_hasSearch? 'templ': ''">
                                  <ng-container [ngTemplateOutlet]="_searchCustom[column.field]"></ng-container>
                              </div>
                          </th>
                      </tr>
                  </thead>
              </ng-template>
              <tbody nz-tbody>
                  <tr nz-tbody-tr *ngFor="let data of nzTable.data; let ri = index" (click)="onRowSelectChange(data)" [style.background]="data.checked? selectColor:'#fff'">
                      <td nz-td nzCheckbox *ngIf="mulitipy">
                          <label #checkbox_item nz-checkbox [(ngModel)]="data.checked" (click)="refreshStatus($event)">
                          </label>
                      </td>
                      <td nz-td nzCheckbox *ngIf="!mulitipy">
                          <label #checkbox_item nz-checkbox [(ngModel)]="data.checked" (click)="refreshSingleStatus($event, nzTable.data, ri)">
                          </label>
                      </td>
                      <td nz-td *ngFor="let column of columns">
                          <ng-template #default_cell>
                              <ng-container *ngIf="column.field === _iconComp[column.field]?.outField" [ngTemplateOutlet]="_iconComp[column.field].iconTemplate" [ngTemplateOutletContext]="data"></ng-container>
                              <a href="javascript:;" *ngIf="column.link" class="column-link">
                                  <span (click)="onCellClick($event,data,column.field)">{{data[column.field]}}</span>
                              </a>
                              <nz-popover *ngIf="!column.link && !column.thumbnail && !column.popover" [nzTrigger]="'hover'">
                                  <span nz-popover>{{replaceTextOmit(data[column.field], column.textLength?column.textLength: 20)}}</span>
                                  <div *ngIf="(data[column.field]?.length>(column.textLength?column.textLength: 20))">
                                      <ng-template #nzTemplate>
                                          <p style="max-width: 300px;">{{data[column.field]}}</p>
                                      </ng-template>
                                  </div>
                              </nz-popover>
                              <!-- 卡片弹框 -->
                              <nz-popover *ngIf="column.popover" [nzTitle]="column.header">
                                  <span class="column-popover-text" nz-popover>{{replaceTextOmit(data[column.field], 20, column.popover)}}</span>
                                  <ng-template #nzTemplate>
                                      <p class="popover-panel popover-content" [class.popover-panel-last]="i === splitName(data[column.field], column.popover).length-1" *ngFor="let name of splitName(data[column.field], column.popover); let i = index;">{{name}}</p>
                                  </ng-template>
                              </nz-popover>
                              <!--图片附件-->
                              <div *ngIf="column.thumbnail && data[column.field] && !column.popover" yzt-viewer>
                                  <i class="anticon anticon-picture thumbnail" *ngFor="let addr of data[column.field]" target="_blank">
                                      <img style="opacity: 0;position: absolute;left: 0;top: 0;" name="{{addr}}" src="{{addr}}">
                                  </i>
                              </div>
                              <ng-container *ngIf="column.field === _customComp[column.field]?.outField" [ngTemplateOutlet]="_customComp[column.field].customTemplate" [ngTemplateOutletContext]="data"></ng-container>
                          </ng-template>
                          <ng-template [ngTemplateOutlet]="default_cell"></ng-template>
                      </td>
                  </tr>
              </tbody>
              <span nz-table-footer>Here is footer</span>
              <div noResult>没有记录</div>
          </nz-table>
      </div>

      <div #edit_box class="edit-wrap" *ngIf="_editCol">
          <div drag-box [box]="edit_box" class="edit-title ant-modal-header">
              <div class="ant-modal-title">编辑列</div>
              <button aria-label="Close" class="ant-modal-close ng-star-inserted" (click)="editCol=false">
                  <span class="ant-modal-close-x"></span>
              </button>
          </div>
          <div class="edit-content ant-modal-body">
              <nz-transfer [nzDataSource]="editColumns" [nzTitles]="['Source', 'Target']" (nzSelectChange)="select($event)" [nzListStyle]="{'width.px': 230, 'height.px': 300, 'text-align': 'left'}" (nzChange)="editChange($event)">
              </nz-transfer>
          </div>
          <div class="edit-footer ant-modal-footer"></div>
      </div>
    `,
    styles: [`
      :host ::ng-deep .ant-table-thead > tr > th.ant-table-selection-column,
      :host ::ng-deep .ant-table-tbody > tr > td.ant-table-selection-column {
        width: 20px;
        min-width: 20px; }

      .grid-border {
        border: 1px solid #e9e9e9; }

      :host /deep/ .ant-table {
        border-radius: 0; }
        :host /deep/ .ant-table .ant-table-title {
          padding: 0 !important;
          top: 0;
          border-radius: 0; }

      .table-title {
        width: 100%;
        overflow: hidden;
        padding: 10px 8px; }
        .table-title .btn-editcol {
          float: left; }
        .table-title .btn-export {
          float: right; }

      :host .header-title > span:first-child {
        display: block; }

      :host .header-title .templ {
        width: 100%;
        height: 30px;
        max-width: 120px; }
        :host .header-title .templ ::ng-deep nz-select,
        :host .header-title .templ ::ng-deep nz-input {
          width: 100%; }

      .column-link {
        text-decoration: underline;
        color: #EE7F25; }

      .edit-wrap {
        width: 600px;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        text-align: center; }

      .thumbnail {
        position: relative;
        overflow: hidden; }

      .popover-panel {
        border-bottom: 1px solid #e9e9e9;
        padding: 8px 16px; }

      .popover-panel-last {
        border: 0; }

      .column-popover-text {
        color: #108ee9; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: GridUtilService, },
{type: ViewContainerRef, },
{type: API, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'gridImg': [{ type: ViewChild, args: ['gridImg', { read: ViewContainerRef }, ] },],
'nzTable': [{ type: ViewChild, args: ['nzTable', ] },],
'load': [{ type: Output },],
'selectionChange': [{ type: Output },],
'cellClick': [{ type: Output },],
'cellOver': [{ type: Output },],
'exportCSV': [{ type: Output },],
'id': [{ type: Input },],
'columns': [{ type: Input },],
'showSizeChanger': [{ type: Input },],
'showPagination': [{ type: Input },],
'pageSizeValues': [{ type: Input },],
'showTitle': [{ type: Input },],
'mulitipy': [{ type: Input },],
'selectColor': [{ type: Input },],
'isSyncData': [{ type: Input },],
'data': [{ type: Input },],
'fixScroll': [{ type: Input },],
'title': [{ type: Input },],
'searchTmpl': [{ type: Input },],
'selection': [{ type: Input },],
};
}

function UIGridComponent_tsickle_Closure_declarations() {
/** @type {?} */
UIGridComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UIGridComponent.ctorParameters;
/** @type {?} */
UIGridComponent.propDecorators;
/** @type {?} */
UIGridComponent.prototype.gridImg;
/** @type {?} */
UIGridComponent.prototype.nzTable;
/** @type {?} */
UIGridComponent.prototype._data;
/** @type {?} */
UIGridComponent.prototype._dataSet;
/** @type {?} */
UIGridComponent.prototype._selections;
/** @type {?} */
UIGridComponent.prototype._loading;
/** @type {?} */
UIGridComponent.prototype._fixScrollY;
/** @type {?} */
UIGridComponent.prototype._title;
/** @type {?} */
UIGridComponent.prototype._titleTpl;
/** @type {?} */
UIGridComponent.prototype._exportLoading;
/** @type {?} */
UIGridComponent.prototype._editCol;
/** @type {?} */
UIGridComponent.prototype.targetColumns;
/** @type {?} */
UIGridComponent.prototype.editColumns;
/** @type {?} */
UIGridComponent.prototype.buttonGather;
/** @type {?} */
UIGridComponent.prototype._page;
/** @type {?} */
UIGridComponent.prototype._size;
/** @type {?} */
UIGridComponent.prototype._pageIndex;
/** @type {?} */
UIGridComponent.prototype._pageSize;
/**
 * 控制多选
 * @type {?}
 */
UIGridComponent.prototype._allChecked;
/** @type {?} */
UIGridComponent.prototype._indeterminate;
/** @type {?} */
UIGridComponent.prototype._displayData;
/** @type {?} */
UIGridComponent.prototype._iconComp;
/** @type {?} */
UIGridComponent.prototype._customComp;
/** @type {?} */
UIGridComponent.prototype._searchCustom;
/** @type {?} */
UIGridComponent.prototype._hasSearch;
/** @type {?} */
UIGridComponent.prototype._popoverStr;
/** @type {?} */
UIGridComponent.prototype._popoverArr;
/** @type {?} */
UIGridComponent.prototype.load;
/** @type {?} */
UIGridComponent.prototype.selectionChange;
/** @type {?} */
UIGridComponent.prototype.cellClick;
/** @type {?} */
UIGridComponent.prototype.cellOver;
/** @type {?} */
UIGridComponent.prototype.exportCSV;
/** @type {?} */
UIGridComponent.prototype.id;
/** @type {?} */
UIGridComponent.prototype.columns;
/** @type {?} */
UIGridComponent.prototype.showSizeChanger;
/** @type {?} */
UIGridComponent.prototype.showPagination;
/** @type {?} */
UIGridComponent.prototype.pageSizeValues;
/** @type {?} */
UIGridComponent.prototype.showTitle;
/** @type {?} */
UIGridComponent.prototype.mulitipy;
/** @type {?} */
UIGridComponent.prototype.selectColor;
/** @type {?} */
UIGridComponent.prototype.isSyncData;
/** @type {?} */
UIGridComponent.prototype.exportDisable;
/** @type {?} */
UIGridComponent.prototype.util;
/** @type {?} */
UIGridComponent.prototype._vcr;
/** @type {?} */
UIGridComponent.prototype.api;
}

export class UIGridModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
        DirectivesModule,
        YZTViewerDirectiveModule
    ],
    declarations: [
        UIGridComponent
    ],
    providers: [
        GridUtilService
    ],
    exports: [UIGridComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UIGridModule_tsickle_Closure_declarations() {
/** @type {?} */
UIGridModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UIGridModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
